import { ReactComponent as Logo } from '../../../images/logo-hr.svg';
import * as Styled from './LogoStyles';

export interface LogoStandardProps {
  logoClass?: string;
  size?: string
	maxWidth?: number,
	hasText?: boolean,
}
interface styleProps {
	[key:string]: any,
}
const defStyle:styleProps = {
	sm: {
		maxWidth: 50,
	},
	md: {
		maxWidth: 77,
	},
	lg: {
		maxWidth: 100,
	},
	def: {
		maxWidth: 55,
	}
}

const TrovaLogo = ({ size, maxWidth, hasText }:LogoStandardProps) => {
	let style = { ...defStyle.def };
	if (size) {
		style = { ...defStyle[size] }
	}
	if (maxWidth) {
		style.maxWidth = maxWidth;
	}
	if (hasText) {
		return (
			<Styled.LogoLink to="/" href="/">
				<Logo style={style} />
				<Styled.LogoText>Trova</Styled.LogoText>
			</Styled.LogoLink>
		)
	}
	return (
		<Styled.LogoLink to="/" href="/">
			<Logo style={style} />
		</Styled.LogoLink>
	);
}

export default TrovaLogo;